// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DebugController from "./debug_controller"
application.register("debug", DebugController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import BridgeMapController from "./bridge/map_controller"
application.register("bridge--map", BridgeMapController)

import BridgeDeviceRegistrationController from "./bridge/device_registration_controller"
application.register("bridge--device-registration", BridgeDeviceRegistrationController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import CrawlChatController from "./crawl_chat_controller"
application.register("crawl-chat", CrawlChatController)

import NotificationBellController from "./notification_bell_controller"
application.register("notification-bell", NotificationBellController)
